import type { ReactNode } from "react";
import React, { useState, useEffect } from "react";
import { clsx } from "clsx";
import {
  buttonDisabled,
  buttonSpinner,
  buttonStyle,
  buttonWidthStyle,
  fullWidthButton
} from "./Button.css";
export type ButtonVariantType =
  | "primary"
  | "secondary"
  | "tertiary"
  | "link"
  | "paypal"; // paypal variant will be removed once express payment experiment finishes

export const DeprecatedUISharedButton: React.FC<{
  variant: ButtonVariantType;
  children: ReactNode;
  loading?: boolean;
  type?: "button" | "submit";
  ariaLabel?: string;
  disabled?: boolean;
  name?: string;
  className?: string;
  fullWidth?: boolean;
  handleClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  dataTestId?: string;
  width?: "default" | "minContent" | "full";
  buttonRef?: React.Ref<HTMLButtonElement>;
}> = ({
  variant = "primary",
  children,
  loading,
  handleClick,
  type,
  ariaLabel,
  disabled,
  name,
  className = "",
  dataTestId = "",
  fullWidth = false,
  width = "default",
  buttonRef
}) => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  return (
    <button
      ref={buttonRef}
      data-testid={dataTestId}
      name={name}
      aria-label={ariaLabel}
      onClick={handleClick}
      type={type === "submit" ? "submit" : "button"}
      className={clsx(
        buttonStyle[variant],
        className,
        fullWidth && fullWidthButton,
        buttonWidthStyle[width],
        disabled && buttonDisabled
      )}
      disabled={!isHydrated || disabled || loading}
    >
      {loading ? <span className={buttonSpinner[variant]} /> : children}
    </button>
  );
};
